// Pesquisa Pós-Compra — cópia de pesquisa-pos-compra-minimal-club.vercel.app
// rodando dentro da loja (sections/pesquisa-pos-compra.liquid).
// As respostas vão para o MESMO Apps Script da planilha de pós-compra
// (docs/pesquisa-pos-compra-apps-script.gs),
// gravadas na aba "Respostas V2" (as da Vercel continuam em "Respostas") e
// o dashboard soma as duas. URL do webhook e aba vêm da configuração da seção.
// "_aba" é só roteamento: o Apps Script tira do payload, não vira coluna.
const SURVEY_ROOT = document.getElementById("pesquisa-pos-compra");
const WEBHOOK_URL = (SURVEY_ROOT && SURVEY_ROOT.dataset.webhookUrl) || "";
const ABA = (SURVEY_ROOT && SURVEY_ROOT.dataset.aba) || "";

// ─────────────────────────────────────────────────────────────
// PERGUNTAS
// Cada opção pode ser uma string simples, ou um objeto
// { label, open: true, placeholder } quando tiver campo aberto.
// ─────────────────────────────────────────────────────────────

const STEPS = [
  {
    name: "Contato",
    questions: [
      {
        id: "q0_email",
        sheetKey: "E-mail",
        type: "email",
        text: "Qual o seu e-mail?",
        placeholder: "seuemail@exemplo.com",
      },
    ],
  },
  {
    name: "Aquisição",
    questions: [
      {
        // Parte 1: canal por onde a pessoa conheceu a Minimal (o "medium").
        id: "q1_canal",
        sheetKey: "Onde conheceu a Minimal",
        type: "single",
        shuffle: true, // ordem aleatória a cada visita, pra não enviesar a resposta
        text: "Onde você conheceu a minimal pela primeira vez?",
        options: [
          "Instagram/Facebook",
          "YouTube",
          "TikTok",
          "Indicação de um amigo",
          "Google/busca",
          { label: "Outro", open: true, placeholder: "Qual?" },
        ],
      },
      {
        // Parte 2: a "fonte" dentro do canal — só aparece se a Parte 1 foi
        // uma rede social (onde faz sentido perguntar influenciador/conteúdo/anúncio).
        id: "q1b_fonte_social",
        sheetKey: "Fonte dentro do canal",
        type: "single",
        showIf: { question: "q1_canal", in: ["Instagram/Facebook", "YouTube", "TikTok"] },
        text: "O que te apresentou a Minimal nessa rede?",
        // Opções variam: "Assisti um review no YouTube" só faz sentido
        // quando o canal escolhido na Parte 1 foi o YouTube.
        options: (ans) => {
          const opts = [{ label: "Influenciador", open: true, placeholder: "Qual?" }];
          if (ans.q1_canal && ans.q1_canal.value === "YouTube") {
            opts.push("Assisti um review no YouTube");
          }
          opts.push("Conteúdo da Minimal", "Anúncio da Minimal", { label: "Outro", open: true, placeholder: "Qual?" });
          return opts;
        },
      },
      {
        id: "q2_motivo_visita",
        sheetKey: "O que trouxe ao site hoje",
        type: "single",
        text: "O que te trouxe ao nosso site hoje?",
        options: [
          "Me lembrei da marca",
          "Recebi um e-mail",
          "Recebi uma mensagem",
          "Alguém me indicou",
          "Vi um post no Instagram",
          "Vi um post no TikTok",
          "Vi um vídeo no YouTube",
          "Estava pesquisando por um produto",
          { label: "Outro", open: true, placeholder: "Qual?" },
        ],
      },
      {
        // Só aparece se a pessoa viu conteúdo em rede social — separa se foi
        // anúncio, perfil oficial da Minimal ou influenciador.
        id: "q2b_fonte_conteudo",
        sheetKey: "Fonte do post/vídeo",
        type: "single",
        showIf: { question: "q2_motivo_visita", in: ["Vi um post no Instagram", "Vi um post no TikTok", "Vi um vídeo no YouTube"] },
        text: "O que você viu exatamente?",
        options: ["Anúncio da Minimal", "Perfil da Minimal", { label: "Influenciador", open: true, placeholder: "Qual?" }],
      },
      {
        id: "q3_tempo_conhecimento",
        sheetKey: "Há quanto tempo conhece a Minimal",
        type: "single",
        text: "Quando você ouviu falar da Minimal pela primeira vez?",
        options: ["Esse mês", "Entre 1 e 3 meses", "Entre 3 meses e 1 ano", "Mais de 1 ano"],
      },
      {
        id: "q4_para_quem",
        sheetKey: "Compra feita para quem",
        type: "single",
        text: "Essa compra foi feita para quem?",
        options: [
          "Para mim",
          { label: "Para outra pessoa", open: true, placeholder: "Quem?" },
          { label: "Para mim e para outra pessoa", open: true, placeholder: "Quem?" },
        ],
      },
      {
        id: "q5_primeira_compra",
        sheetKey: "Primeira compra na Minimal",
        type: "single",
        text: "Esta é sua primeira compra na Minimal?",
        options: ["Sim, primeira vez", "Não, já comprei antes"],
      },
      {
        id: "q6_motivo_retorno",
        sheetKey: "O que trouxe de volta",
        type: "single",
        text: "O que te trouxe de volta hoje?",
        showIf: { question: "q5_primeira_compra", equals: "Não, já comprei antes" },
        options: [
          "Gostei das peças e quis comprar mais",
          "Vi um lançamento novo",
          "Recebi uma promoção ou cupom",
          "Lembrei da marca espontaneamente",
          "Fui indicar para alguém e acabei comprando também",
          { label: "Outro", open: true, placeholder: "Qual?" },
        ],
      },
    ],
  },
  {
    name: "Perfil",
    questions: [
      {
        id: "q7_faixa_etaria",
        sheetKey: "Faixa etária",
        type: "single",
        text: "Qual a sua faixa etária?",
        options: ["Até 24 anos", "25 a 34 anos", "35 a 44 anos", "45 a 54 anos", "55 a 64 anos", "65 anos ou mais"],
      },
      {
        id: "q8_sexo",
        sheetKey: "Sexo",
        type: "single",
        text: "Qual o seu sexo?",
        options: ["Masculino", "Feminino", "Prefiro não informar"],
      },
      {
        id: "q9_profissao",
        sheetKey: "Profissão",
        type: "single",
        text: "Qual a sua profissão?",
        options: [
          "Empresário / empreendedor",
          "Executivo / gestor",
          "Profissional liberal (médico, advogado, engenheiro)",
          "Servidor público",
          "Profissional de tecnologia",
          "Profissional financeiro",
          "Estudante",
          { label: "Outro", open: true, placeholder: "Qual?" },
        ],
      },
      {
        id: "q10_escolaridade",
        sheetKey: "Escolaridade",
        type: "single",
        text: "Qual o seu nível de escolaridade?",
        options: ["Ensino médio completo", "Superior incompleto", "Superior completo", "Pós-graduação / MBA", "Mestrado ou doutorado"],
      },
    ],
  },
  {
    name: "Experiência no site",
    questions: [
      {
        id: "q11_facilidade_produto",
        sheetKey: "Encontrou o produto com facilidade",
        type: "single",
        text: "Você encontrou com facilidade o produto que queria no nosso site?",
        options: ["Sim", { label: "Não", open: true, placeholder: "O que aconteceu?" }],
      },
      {
        id: "q12_informacoes_produto",
        sheetKey: "Encontrou as informações do produto",
        type: "single",
        text: "No site você encontrou todas as informações que precisava sobre o produto?",
        sub: "Composição, tamanho, materiais e cuidados?",
        options: [
          "Sim",
          { label: "Encontrei essas, mas precisava de mais informações", open: true, placeholder: "Quais informações você gostaria de ter acesso?" },
          { label: "Não", open: true, placeholder: "O que aconteceu?" },
        ],
      },
      {
        id: "q13_comunicacao_clara",
        sheetKey: "Comunicação do site clara",
        type: "single",
        text: "A comunicação do site estava clara?",
        options: ["Sim", { label: "Não", open: true, placeholder: "O que não ficou claro?" }],
      },
      {
        id: "q14_pagamento_simples",
        sheetKey: "Pagamento simples",
        type: "single",
        text: "O processo de pagamento foi simples?",
        options: ["Sim", { label: "Não", open: true, placeholder: "O que aconteceu?" }],
      },
      {
        id: "q15_frete_caro",
        sheetKey: "Percepção sobre o frete",
        type: "single",
        text: "O frete te pareceu caro?",
        options: ["Não, achei justo", "Um pouco caro", "Sim, muito caro", "Consegui frete grátis"],
      },
      {
        id: "q16_anuncio_alinhado",
        sheetKey: "Anúncio alinhado ao site",
        type: "single",
        text: "O anúncio que você viu representava bem o que encontrou no site?",
        options: ["Sim, estava alinhado", "Mais ou menos", "Não vi nenhum anúncio"],
      },
      {
        id: "q17_outra_dificuldade",
        sheetKey: "Outra dificuldade no site",
        type: "single",
        text: "Teve alguma outra dificuldade no site?",
        options: ["Não", { label: "Sim", open: true, placeholder: "Conte o que aconteceu" }],
      },
    ],
  },
  {
    name: "Decisão de compra",
    questions: [
      {
        id: "q18_preco_percebido",
        sheetKey: "Percepção sobre o preço",
        type: "single",
        text: "Como você considera o preço dos nossos produtos?",
        options: ["Barato", "Justo", "Caro"],
      },
      {
        id: "q19_frequencia_compra_roupas",
        sheetKey: "Frequência de compra de roupas em geral",
        type: "single",
        text: "Com que frequência você costuma comprar roupas?",
        options: ["Menos de 1 vez por ano", "1 a 2 vezes por ano", "3 a 4 vezes por ano", "5 vezes ou mais por ano"],
      },
      {
        id: "q20_frequencia_compra_minimal",
        sheetKey: "Frequência de compra na Minimal",
        type: "single",
        text: "Com que frequência você compra na Minimal?",
        options: ["É minha primeira compra", "1 vez por ano", "2 a 3 vezes por ano", "4 vezes ou mais por ano"],
      },
      {
        id: "q21_outras_marcas",
        sheetKey: "Outras marcas consideradas",
        type: "multi",
        text: "Você considerou alguma outra marca antes de comprar na Minimal?",
        sub: "Possível marcar mais de uma opção",
        options: [
          "Nenhuma", "Insider", "Reserva", "Hering", "Renner", "Oficina",
          "Ricardo Almeida", "Basicamente", "Urbo", "Lawe",
          { label: "Outra", open: true, placeholder: "Qual?" },
        ],
      },
      {
        id: "q22_motivo_compra",
        sheetKey: "Motivo da compra",
        type: "multi",
        text: "O que motivou sua compra?",
        sub: "Possível marcar mais de uma opção",
        options: [
          "Preço", "Qualidade", "Modelagem / caimento", "Custo-benefício",
          "Prazo de entrega", "Queria conhecer a marca", "Garantia de devolução",
          { label: "Outro", open: true, placeholder: "Qual?" },
        ],
      },
      {
        id: "q23_loja_fisica",
        sheetKey: "Preferência por loja física",
        type: "single",
        text: "Você preferiria poder comprar em loja física?",
        options: ["Não, prefiro online", "Para alguns produtos sim", "Sim, preferiria ter a opção"],
      },
      {
        id: "q24_proximo_produto",
        sheetKey: "Sugestão de próximo produto",
        type: "text",
        required: false,
        text: "Se você decidisse o próximo produto da Minimal, qual seria?",
        placeholder: "Escreva sua ideia aqui...",
      },
    ],
  },
];

// ─────────────────────────────────────────────────────────────
// ESTADO
// ─────────────────────────────────────────────────────────────

// Lista única com todas as perguntas, na ordem, independente da etapa.
// A etapa (STEPS) continua existindo só para organizar o sheetKey/config.
const ALL_QUESTIONS = STEPS.flatMap((step) => step.questions);

const answers = {}; // { [questionId]: { value, detail } | { value: [] } para multi }
let currentIndex = 0;

// ID único por sessão de resposta: permite ir atualizando a mesma linha
// na planilha conforme a pessoa avança, em vez de só salvar no envio final.
const RESPONSE_ID = (crypto.randomUUID && crypto.randomUUID()) || `${Date.now()}-${Math.random().toString(16).slice(2)}`;
let surveyStatus = "Em andamento";

const form = document.getElementById("survey-form");
const progressFill = document.getElementById("progress-fill");
const surveyCard = document.getElementById("survey-card");
const telaObrigado = document.getElementById("tela-obrigado");

// ─────────────────────────────────────────────────────────────
// VISIBILIDADE / NAVEGAÇÃO
// ─────────────────────────────────────────────────────────────

function normalizeOption(opt) {
  return typeof opt === "string" ? { label: opt, open: false } : opt;
}

// Embaralha as opções (Fisher-Yates), mantendo "Outro" sempre por último.
function shuffleOptions(opts) {
  const pinned = opts.filter((o) => o.label === "Outro");
  const rest = opts.filter((o) => o.label !== "Outro");
  for (let i = rest.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [rest[i], rest[j]] = [rest[j], rest[i]];
  }
  return [...rest, ...pinned];
}

function isQuestionVisible(question) {
  if (!question.showIf) return true;
  const dep = answers[question.showIf.question];
  if (!dep) return false;
  if (question.showIf.in) return question.showIf.in.includes(dep.value);
  return dep.value === question.showIf.equals;
}

function nextVisibleIndex(fromIndex) {
  let i = fromIndex + 1;
  while (i < ALL_QUESTIONS.length && !isQuestionVisible(ALL_QUESTIONS[i])) i++;
  return i;
}

function prevVisibleIndex(fromIndex) {
  let i = fromIndex - 1;
  while (i >= 0 && !isQuestionVisible(ALL_QUESTIONS[i])) i--;
  return i;
}

// ─────────────────────────────────────────────────────────────
// RENDERIZAÇÃO — uma pergunta por tela
// ─────────────────────────────────────────────────────────────

function buildOptionEl(question, opt) {
  const type = question.type === "multi" ? "checkbox" : "radio";
  const saved = answers[question.id];

  const wrap = document.createElement("div");
  wrap.className = "option-wrap";

  const btn = document.createElement("button");
  btn.type = "button";
  btn.className = "option";
  btn.dataset.type = type;
  btn.dataset.value = opt.label;

  const indicator = document.createElement("span");
  indicator.className = "option-indicator";
  indicator.innerHTML = type === "checkbox" ? '<span class="check">✓</span>' : '<span class="dot"></span>';

  const labelEl = document.createElement("span");
  labelEl.className = "option-label";
  labelEl.textContent = opt.label;

  btn.appendChild(indicator);
  btn.appendChild(labelEl);
  wrap.appendChild(btn);

  const isPreSelected =
    question.type === "multi"
      ? !!saved && saved.value.includes(opt.label)
      : !!saved && saved.value === opt.label;

  let openInput = null;
  if (opt.open) {
    const openWrap = document.createElement("div");
    openWrap.className = "option-open";
    openWrap.hidden = !isPreSelected;

    openInput = document.createElement("input");
    openInput.type = "text";
    openInput.placeholder = opt.placeholder || "Conte mais...";
    openInput.autocomplete = "off";
    if (isPreSelected) {
      openInput.value = question.type === "multi" ? (saved.details && saved.details[opt.label]) || "" : saved.detail || "";
    }

    openInput.addEventListener("input", () => {
      const current = answers[question.id];
      if (!current) return;
      if (question.type === "multi") {
        current.details = current.details || {};
        current.details[opt.label] = openInput.value;
      } else if (current.value === opt.label) {
        current.detail = openInput.value;
      }
      scheduleIdleSync();
    });

    openWrap.appendChild(openInput);
    wrap.appendChild(openWrap);
  }

  if (isPreSelected) btn.classList.add("selected");

  btn.addEventListener("click", () => {
    const isSelected = btn.classList.contains("selected");

    if (question.type === "multi") {
      const current = (answers[question.id] = answers[question.id] || { value: [], details: {} });
      if (isSelected) {
        btn.classList.remove("selected");
        current.value = current.value.filter((v) => v !== opt.label);
        if (openInput) openInput.parentElement.hidden = true;
      } else {
        btn.classList.add("selected");
        current.value.push(opt.label);
        if (openInput) {
          openInput.parentElement.hidden = false;
          openInput.focus();
        }
      }
    } else {
      // radio: desmarca irmãos
      wrap.parentElement.querySelectorAll(".option").forEach((sibling) => {
        sibling.classList.remove("selected");
        const siblingOpen = sibling.parentElement.querySelector(".option-open");
        if (siblingOpen) siblingOpen.hidden = true;
      });
      btn.classList.add("selected");
      answers[question.id] = { value: opt.label, detail: opt.open ? "" : undefined };
      if (openInput) {
        openInput.parentElement.hidden = false;
        openInput.focus();
      }
    }

    clearQuestionError();
    scheduleIdleSync();
  });

  return wrap;
}

function buildQuestionScreen(question) {
  const el = document.createElement("div");
  el.className = "question";
  el.dataset.questionId = question.id;

  const title = document.createElement("p");
  title.className = "question-title";
  title.textContent = question.text;
  if (question.required !== false) {
    const dot = document.createElement("span");
    dot.className = "req-dot";
    dot.textContent = "*";
    title.appendChild(dot);
  }
  el.appendChild(title);

  if (question.sub) {
    const sub = document.createElement("p");
    sub.className = "question-sub";
    sub.textContent = question.sub;
    el.appendChild(sub);
  }

  if (question.type === "email") {
    const input = document.createElement("input");
    input.type = "email";
    input.placeholder = question.placeholder || "";
    input.autocomplete = "email";
    input.value = (answers[question.id] && answers[question.id].value) || "";
    input.addEventListener("input", () => {
      answers[question.id] = { value: input.value };
      scheduleIdleSync();
    });
    el.appendChild(input);
  } else if (question.type === "text") {
    const textarea = document.createElement("textarea");
    textarea.placeholder = question.placeholder || "";
    textarea.value = (answers[question.id] && answers[question.id].value) || "";
    textarea.addEventListener("input", () => {
      answers[question.id] = { value: textarea.value };
      scheduleIdleSync();
    });
    el.appendChild(textarea);
  } else {
    const list = document.createElement("div");
    list.className = "options-list";
    // question.options pode ser um array fixo ou uma função (answers) => array,
    // pra quando as opções dependem da resposta de outra pergunta.
    const rawOptions = typeof question.options === "function" ? question.options(answers) : question.options;
    if (rawOptions.length > 8) list.classList.add("options-list--grid");
    let opts = rawOptions.map(normalizeOption);
    if (question.shuffle) opts = shuffleOptions(opts);
    opts.forEach((opt) => {
      list.appendChild(buildOptionEl(question, opt));
    });
    el.appendChild(list);
  }

  const error = document.createElement("p");
  error.className = "field-error";
  error.textContent = question.type === "email" ? "Digite um e-mail válido." : "Escolha uma opção para continuar.";
  el.appendChild(error);

  return el;
}

function renderCurrentQuestion() {
  const question = ALL_QUESTIONS[currentIndex];

  const screen = document.createElement("div");
  screen.className = "step";

  screen.appendChild(buildQuestionScreen(question));

  const actions = document.createElement("div");
  actions.className = "step-actions";

  if (prevVisibleIndex(currentIndex) >= 0) {
    const back = document.createElement("button");
    back.type = "button";
    back.className = "btn-link";
    back.textContent = "← Voltar";
    back.addEventListener("click", () => {
      currentIndex = prevVisibleIndex(currentIndex);
      renderCurrentQuestion();
    });
    actions.appendChild(back);
  }

  const isLast = nextVisibleIndex(currentIndex) >= ALL_QUESTIONS.length;
  const next = document.createElement("button");
  next.type = isLast ? "submit" : "button";
  next.className = "btn-primary";
  next.textContent = isLast ? "Enviar respostas →" : "Continuar →";
  if (!isLast) {
    next.addEventListener("click", attemptAdvance);
  }
  actions.appendChild(next);

  screen.appendChild(actions);

  form.innerHTML = "";
  form.appendChild(screen);

  updateProgress();
  window.scrollTo({ top: 0, behavior: "smooth" });
}

// ─────────────────────────────────────────────────────────────
// VALIDAÇÃO
// ─────────────────────────────────────────────────────────────

function clearQuestionError() {
  const el = form.querySelector(".question");
  if (el) el.classList.remove("has-error");
}

function isQuestionAnswered(question) {
  if (question.required === false) return true;
  const val = answers[question.id];
  if (!val) return false;
  if (question.type === "multi") return Array.isArray(val.value) && val.value.length > 0;
  if (question.type === "text") return true; // opcional
  if (question.type === "email") return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val.value || "");
  return !!val.value;
}

function validateCurrentQuestion() {
  const question = ALL_QUESTIONS[currentIndex];
  if (isQuestionAnswered(question)) return true;

  const el = form.querySelector(".question");
  if (el) {
    el.classList.add("has-error");
    el.scrollIntoView({ behavior: "smooth", block: "center" });
  }
  return false;
}

function attemptAdvance() {
  if (!validateCurrentQuestion()) return;
  currentIndex = nextVisibleIndex(currentIndex);
  renderCurrentQuestion();
}

// Progresso "falso": não é linear com o número real de perguntas.
// Sobe rápido no início (dá a sensação de que já foi longe) e desacelera
// no fim, mas sempre chega em 100% na última pergunta.
function updateProgress() {
  const total = ALL_QUESTIONS.length;
  const t = currentIndex / (total - 1);
  const eased = 1 - Math.pow(1 - t, 2);
  const percent = 10 + eased * 90;
  progressFill.style.width = `${percent}%`;
}

// ─────────────────────────────────────────────────────────────
// ENVIO
// ─────────────────────────────────────────────────────────────

function buildPayload() {
  const payload = {
    "ID da resposta": RESPONSE_ID,
    "Status": surveyStatus,
    "Data/Hora": new Date().toLocaleString("pt-BR"),
  };
  if (ABA) payload._aba = ABA;

  ALL_QUESTIONS.forEach((q) => {
    const val = answers[q.id];
    if (!val) return;

    if (q.type === "multi") {
      payload[q.sheetKey] = (val.value || []).join(", ");
      Object.entries(val.details || {}).forEach(([label, detail]) => {
        if (detail) payload[`${q.sheetKey} - detalhe (${label})`] = detail;
      });
    } else {
      payload[q.sheetKey] = val.value || "";
      if (val.detail) payload[`${q.sheetKey} - detalhe`] = val.detail;
    }
  });

  return payload;
}

async function postToSheet(payload) {
  if (!WEBHOOK_URL || WEBHOOK_URL.startsWith("COLE_AQUI")) {
    console.warn("WEBHOOK_URL não configurado. Respostas coletadas:", payload);
    return;
  }
  await fetch(WEBHOOK_URL, {
    method: "POST",
    mode: "no-cors",
    keepalive: true, // dá mais chance da requisição terminar se a aba for fechada
    headers: { "Content-Type": "text/plain;charset=utf-8" },
    body: JSON.stringify(payload),
  });
}

// Salva o progresso parcial sem bloquear a navegação nem incomodar
// a pessoa com erro caso a rede falhe momentaneamente.
function syncToSheet() {
  postToSheet(buildPayload()).catch((err) => console.error("Falha ao sincronizar com a planilha:", err));
}

// Só salva de fato quando a pessoa: (1) termina a pesquisa, (2) sai/troca de
// aba, ou (3) fica parada mais de IDLE_SYNC_MS sem responder nada — em vez de
// bater no webhook a cada clique, o que gerava uma linha por resposta.
const IDLE_SYNC_MS = 10000;
let idleTimer = null;

function scheduleIdleSync() {
  clearTimeout(idleTimer);
  idleTimer = setTimeout(syncToSheet, IDLE_SYNC_MS);
}

async function submitForm(event) {
  event.preventDefault();

  if (!validateCurrentQuestion()) return;

  clearTimeout(idleTimer);

  const submitBtn = form.querySelector('button[type="submit"]');
  submitBtn.disabled = true;
  submitBtn.textContent = "Enviando...";

  surveyStatus = "Completo";

  try {
    await postToSheet(buildPayload());
    surveyCard.hidden = true;
    telaObrigado.hidden = false;
  } catch (err) {
    submitBtn.disabled = false;
    submitBtn.textContent = "Enviar respostas →";
    alert("Não foi possível enviar suas respostas agora. Verifique sua conexão e tente novamente.");
    console.error(err);
  }
}

form.addEventListener("submit", submitForm);

renderCurrentQuestion();

const introCard = document.getElementById("intro-card");
document.getElementById("btn-iniciar").addEventListener("click", () => {
  introCard.hidden = true;
  surveyCard.hidden = false;
  window.scrollTo({ top: 0, behavior: "smooth" });
});

// Rede de segurança: se a pessoa fechar a aba, trocar de app, minimizar
// ou sair da página no meio da pesquisa, tenta salvar o progresso mesmo assim.
function syncOnExit() {
  if (!surveyCard.hidden) {
    clearTimeout(idleTimer);
    syncToSheet();
  }
}
document.addEventListener("visibilitychange", () => {
  if (document.visibilityState === "hidden") syncOnExit();
});
window.addEventListener("pagehide", syncOnExit);
